import { styled } from '@mui/material/styles';
import { Stack, Typography } from 'core/common/ui/ui-kit';

export const CardWrapperStyled = styled(Stack)`
  gap: ${({ theme }) => theme.spacing(4)};
  padding: 20px;
  border-radius: 16px;
  background-color: ${({ theme }) => theme.palette.contentBlockBackground.secondary};
`;

export const FooterStyled = styled(Stack)`
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  gap: ${({ theme }) => theme.spacing(3)};
  margin-top: ${({ theme }) => theme.spacing(4)};
`;

export const BadgeStyled = styled(Typography)`
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacing(1)};
  color: ${({ theme }) => theme.palette.text.secondary};
`;

export const DateStyled = styled(Typography)`
  margin-top: auto;
  color: ${({ theme }) => theme.palette.text.secondary};
`;
